import routes from './router'

export default { routes }
